import React from 'react'

import {
  ApprovedIcon,
  FailedIcon,
  IconContainer,
  PendingIcon,
  ProcessingIcon,
  RejectedIcon
} from 'modules/requests/filters/StatusFilter.styles'
import { ImportRequestStatus as ImportRequestStatusEnum } from 'services/import-requests/enums'
import { getImportRequestStatusLabel } from 'services/import-requests/importRequestStatusLabels'

interface ImportRequestStatusProps {
  status: ImportRequestStatusEnum
}

export const ImportRequestStatus = ({ status }: ImportRequestStatusProps): JSX.Element | null => {
  const label = getImportRequestStatusLabel(status)

  switch (status) {
    case ImportRequestStatusEnum.PendingUpload:
    case ImportRequestStatusEnum.PendingVerification:
    case ImportRequestStatusEnum.Pending:
      return (
        <IconContainer>
          <PendingIcon />
          <span>{label}</span>
        </IconContainer>
      )
    case ImportRequestStatusEnum.Scanning:
    case ImportRequestStatusEnum.Processing:
    case ImportRequestStatusEnum.CopyingExternalCloudLocation:
    case ImportRequestStatusEnum.CopyingToAirlockInBucket:
      return (
        <IconContainer>
          <ProcessingIcon text={false} />
          <span>{label}</span>
        </IconContainer>
      )
    case ImportRequestStatusEnum.Approved:
    case ImportRequestStatusEnum.Available:
      return (
        <IconContainer>
          <ApprovedIcon />
          <span>{label}</span>
        </IconContainer>
      )
    case ImportRequestStatusEnum.Failed:
      return (
        <IconContainer>
          <FailedIcon />
          <span>{label}</span>
        </IconContainer>
      )
    case ImportRequestStatusEnum.Rejected:
      return (
        <IconContainer>
          <RejectedIcon />
          <span>{label}</span>
        </IconContainer>
      )
    default:
      return null
  }
}
